module.exports = __webpack_public_path__ + "static/media/5.7a9a4bd1.svg";